import React from 'react'
import gql from 'graphql-tag'
import { Mutation, MutationFn } from 'react-apollo'
import { SubstatusName } from '../vulnerability-status/status'

export const substatusAliasSettingsMutation = gql`
  mutation updateVulnerabilitySubstatusAlias(
    $organizationUuid: ID!
    $substatus: SubstatusArgs!
    $label: String!
  ) {
    updateVulnerabilitySubstatusAlias(
      input: {
        organizationUuid: $organizationUuid
        substatus: $substatus
        label: $label
      }
    ) {
      _placeholder
    }
  }
`

interface ChildProps {
  readonly children: (
    updateSubstatusAliasSettings: MutationFn<
      {},
      SubstatusAliasSettingsMutationArgs
    >
  ) => React.ReactNode
}

export interface SubstatusAliasSettingsMutationArgs {
  readonly organizationUuid: string
  readonly substatus: SubstatusName
  readonly label: string
}

export function SubstatusAliasSettingsMutation({ children }: ChildProps) {
  return (
    <Mutation<{}, SubstatusAliasSettingsMutationArgs>
      mutation={substatusAliasSettingsMutation}
    >
      {(updateSubstatusAliasSettings) => {
        return children(updateSubstatusAliasSettings)
      }}
    </Mutation>
  )
}
